<template>
  <div v-if="count === 3" class="counter three-slot">
    <v-icon :icon="['far', 'square']" />
    <v-icon :icon="['far', 'square']" />
    <v-icon :icon="['far', 'square']" />
  </div>
  <div v-if="count > 3" class="counter error-space">
    <v-icon :icon="['far', 'square']" />
    <v-icon :icon="['far', 'square']" />
    <v-icon :icon="['far', 'square']" />
  </div>

  <div v-if="count === 2" class="counter twice-slot">
    <v-icon :icon="['fas', 'square']" />
    <v-icon :icon="['far', 'square']" />
    <v-icon :icon="['far', 'square']" />
  </div>

  <div v-if="count === 1" class="counter one-slot">
    <v-icon :icon="['fas', 'square']" />
    <v-icon :icon="['fas', 'square']" />
    <v-icon :icon="['far', 'square']" />
  </div>

  <div v-if="count === 0" class="counter zero-space">
    <v-icon :icon="['fas', 'square']" />
    <v-icon :icon="['fas', 'square']" />
    <v-icon :icon="['fas', 'square']" />
  </div>

  <div v-if="count < 0" class="counter error-space">
    <v-icon :icon="['fas', 'square']" />
    <v-icon :icon="['fas', 'square']" />
    <v-icon :icon="['fas', 'square']" />
  </div>
</template>

<script>
export default {
  name: "LighterElement",
  props: ['count']
}
</script>

<style scoped lang="scss">
.counter {
  * {
    margin-right: 1px;
  }
}
.three-slot {
  color: #dddddd;
}
.twice-slot {
  color: #3aa245;
}
.one-slot {
  color: #c2b140;
}
.zero-space {
  color: #c34a4a;
}

.error-space {
  color: #252525;
}
</style>